<template>
  <div :class="[alert, alertType, alertDismissible]" id="alert" role="alert">
    <button type="button" class="close" aria-label="Close" @click="dismiss"><span aria-hidden="true">×</span></button>
    <span v-if="isError">{{ error }}</span><span v-if="isMessage">{{ message }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Alert',
  data () {
    return {
      alert: 'alert',
      alertType: 'alert-' + this.type,
      alertDismissible: 'alert-dismissable'
    }
  },
  computed: {
    ...mapState([
      'error',
      'message'
    ]),
    isError () {
      return this.type === 'danger'
    },
    isMessage () {
      return this.type === 'primary'
    }
  },
  props: ['type'],
  methods: {
    dismiss (e) {
      if (this.type === 'danger') {
        this.$store.commit('clearError')
      }
      if (this.type === 'primary') {
        this.$store.commit('clearMessage')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Alert.vue